import HeartbeatLoader from '@/components/ui/loaders/HeartbeatLoader'
import { Stack } from '@mui/material'

export function DmpConnectLoading({ message }: { message: string }) {
  return (
    <Stack height="100%" alignItems="center" justifyContent="center">
      <HeartbeatLoader />
      {message}
    </Stack>
  )
}
